import comp from "./TagResourceV2";
export default comp;
